/**
 * @deprecated Replaced by gf-motion-core.js + gf-motion-loader.js + gf-motion-deferred.js
 * Kept for reference only — no longer loaded by theme.liquid.
 */
(function () {
  'use strict';
})();
